import { RAKSHA_SEATS } from './raksha.js';

/**
 * What a fare-paying vehicle needs to tell the hitchhiker manager.
 *
 * The manager drives one ride state machine for every vehicle that carries
 * passengers. A raksha and a minibus differ in only three things: how many
 * people fit, where they sit, and which side they get in on. Everything else —
 * hailing, walking to the door, climbing in, riding, alighting — is identical,
 * so it lives in `hitchhikers.js` and reads these tables.
 *
 * Local axes match the rest of the scripted traffic: the nose points down -Z
 * and the vehicle's right-hand side is +X.
 */

/** Six seats, two abreast, facing forward behind the sliding door. `y` is the
 *  cabin floor, because a figure's origin is at its feet. */
export const BUS_SEATS = [
  { x: -0.48, y: 0.7, z: -0.05 },
  { x: 0.48, y: 0.7, z: -0.05 },
  { x: -0.48, y: 0.7, z: 1.1 },
  { x: 0.48, y: 0.7, z: 1.1 },
  { x: -0.48, y: 0.7, z: 2.25 },
  { x: 0.48, y: 0.7, z: 2.25 },
];

/** Where a passenger stands before climbing aboard. The raksha's tub is open at
 *  the back; the minibus loads through the sliding door on its right. */
export const RAKSHA_DOOR = { x: 0, z: 1.72 };
export const BUS_DOOR = { x: 1.46, z: -0.95 };

/** The side a vehicle loads from, in local X. A raksha takes fares from any
 *  side; a minibus only from the kerb its door faces. */
const RAKSHA_DOOR_SIDE = 0;
const BUS_DOOR_SIDE = 1;

const isBus = (car) => car?.rideType === 'bus';

export function rideSeats(car) {
  return isBus(car) ? BUS_SEATS : RAKSHA_SEATS;
}

export function rideDoorPoint(car) {
  return isBus(car) ? BUS_DOOR : RAKSHA_DOOR;
}

export function rideDoorSide(car) {
  return isBus(car) ? BUS_DOOR_SIDE : RAKSHA_DOOR_SIDE;
}
